// useReverteDfdModal.js
import { useState } from 'react';

const useReverteDfdModal = () => {
    const [setReverteDfdModal, setModalProps] = useState({
        isOpen: false,
        dfd: null,
        onSuccess: () => {}
    });

    const showReverteDfdModal = (dfd, onSuccess) => {
        setModalProps({
            isOpen: true,
            dfd,
            onSuccess
        });
    };

    const closeReverteDfdModal = () => {
        setModalProps(prev => ({
            ...prev,
            isOpen: false
        }));
    };

    return {
        setReverteDfdModal,
        showReverteDfdModal,
        closeReverteDfdModal
    };
};

export default useReverteDfdModal;